import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ai247-instance-detail" }
const _hoisted_2 = { class: "ai247-instance-detail__header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ai247-instance-detail__label" }, "Instance details", -1)
const _hoisted_4 = { class: "ai247-instance-detail__title" }
const _hoisted_5 = { class: "ai247-instance-detail__subtitle" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "ai247-instance-row__badge"
}
const _hoisted_9 = { class: "ai247-instance-detail__stats" }
const _hoisted_10 = { class: "ai247-instance-detail__stat-card" }
const _hoisted_11 = { class: "ai247-instance-detail__stat-value" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "ai247-instance-detail__stat-label" }, "Portal status", -1)
const _hoisted_13 = { class: "ai247-instance-detail__stat-card" }
const _hoisted_14 = { class: "ai247-instance-detail__stat-value" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "ai247-instance-detail__stat-label" }, "Created", -1)
const _hoisted_16 = { class: "ai247-instance-detail__body" }
const _hoisted_17 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_18 = {
  key: 0,
  class: "alert alert-info d-flex align-items-center mb-3"
}
const _hoisted_19 = { class: "svg-icon svg-icon-2hx svg-icon-info me-4" }
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = { class: "fw-bold" }
const _hoisted_22 = { class: "text-muted fs-7" }
const _hoisted_23 = {
  key: 1,
  class: "alert alert-success d-flex align-items-center mb-3"
}
const _hoisted_24 = { class: "svg-icon svg-icon-2hx svg-icon-success me-4" }
const _hoisted_25 = { class: "d-flex flex-column" }
const _hoisted_26 = { class: "fw-bold" }
const _hoisted_27 = { class: "text-muted fs-7" }
const _hoisted_28 = {
  key: 2,
  class: "alert alert-warning d-flex align-items-center mb-3"
}
const _hoisted_29 = { class: "svg-icon svg-icon-2hx svg-icon-warning me-4" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bold" }, "Subscription payment failed"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fs-7" }, " We could not renew your subscription. Renew below to avoid losing access to your AI 24/7. ")
], -1)
const _hoisted_31 = {
  key: 3,
  class: "alert alert-danger d-flex align-items-center mb-3"
}
const _hoisted_32 = { class: "svg-icon svg-icon-2hx svg-icon-danger me-4" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bold" }, "Subscription expired"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fs-7" }, " Your AI 24/7 access is suspended. Subscribe below to restore posting, fan-out, and AI features. ")
], -1)
const _hoisted_34 = {
  key: 4,
  class: "d-flex gap-3"
}
const _hoisted_35 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Subscribe Monthly ")
const _hoisted_37 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Subscribe Quarterly ")
const _hoisted_39 = { class: "alert alert-success d-flex align-items-center mb-5" }
const _hoisted_40 = { class: "svg-icon svg-icon-2hx svg-icon-success me-4" }
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bold" }, "Your AI 24/7 is active."),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fs-7" }, " You can manage prospects and CRM features through your AI 24/7 location. ")
], -1)
const _hoisted_42 = { class: "table-responsive" }
const _hoisted_43 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_44 = /*#__PURE__*/_createVNode("td", { class: "ps-4 pe-4 fw-semibold text-gray-800" }, "Location ID", -1)
const _hoisted_45 = { class: "pe-4 text-muted" }
const _hoisted_46 = /*#__PURE__*/_createVNode("td", { class: "ps-4 pe-4 fw-semibold text-gray-800" }, "Status", -1)
const _hoisted_47 = { class: "pe-4" }
const _hoisted_48 = { class: "badge badge-light-success text-uppercase" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/_createVNode("td", { class: "ps-4 pe-4 fw-semibold text-gray-800" }, "Created", -1)
const _hoisted_51 = { class: "pe-4 text-muted" }
const _hoisted_52 = { class: "alert alert-warning d-flex align-items-center mb-5" }
const _hoisted_53 = { class: "svg-icon svg-icon-2hx svg-icon-warning me-4" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bold" }, "Pending Application"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fs-7" }, " Your AI 24/7 sub-account has been created. An administrator will review and approves your application before your portal becomes active. ")
], -1)
const _hoisted_55 = { class: "table-responsive mb-5" }
const _hoisted_56 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_57 = /*#__PURE__*/_createVNode("td", { class: "ps-4 pe-4 fw-semibold text-gray-800" }, "Location ID", -1)
const _hoisted_58 = { class: "pe-4 text-muted" }
const _hoisted_59 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", { class: "ps-4 pe-4 fw-semibold text-gray-800" }, "Status"),
  /*#__PURE__*/_createVNode("td", { class: "pe-4" }, [
    /*#__PURE__*/_createVNode("span", { class: "badge badge-light-warning text-uppercase" }, "Pending Application")
  ])
], -1)
const _hoisted_60 = { key: 0 }
const _hoisted_61 = /*#__PURE__*/_createVNode("td", { class: "ps-4 pe-4 fw-semibold text-gray-800" }, "Created", -1)
const _hoisted_62 = { class: "pe-4 text-muted" }
const _hoisted_63 = {
  key: 3,
  class: "table-responsive"
}
const _hoisted_64 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_65 = /*#__PURE__*/_createVNode("td", { class: "ps-4 pe-4 fw-semibold text-gray-800" }, "Location ID", -1)
const _hoisted_66 = { class: "pe-4 text-muted" }
const _hoisted_67 = /*#__PURE__*/_createVNode("td", { class: "ps-4 pe-4 fw-semibold text-gray-800" }, "Status", -1)
const _hoisted_68 = { class: "pe-4" }
const _hoisted_69 = { class: "badge badge-light-warning text-uppercase" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = /*#__PURE__*/_createVNode("td", { class: "ps-4 pe-4 fw-semibold text-gray-800" }, "Created", -1)
const _hoisted_72 = { class: "pe-4 text-muted" }
const _hoisted_73 = {
  key: 4,
  class: "alert alert-warning d-flex align-items-center mb-5"
}
const _hoisted_74 = { class: "svg-icon svg-icon-2hx svg-icon-warning me-4" }
const _hoisted_75 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-bold" }, "Activation required"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fs-7" }, " You need an AI 24/7 activation to sign up. Purchase or receive an activation slot, then select it from the instances panel to create your location. ")
], -1)
const _hoisted_76 = { class: "alert alert-primary d-flex align-items-center mb-5" }
const _hoisted_77 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }
const _hoisted_78 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createVNode("span", null, " Sign up for a AI 24/7 to manage your business CRM, contacts, and marketing tools. Review your details below and submit to create your location. ")
], -1)
const _hoisted_79 = { class: "seq-profile-row" }
const _hoisted_80 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Account Name", -1)
const _hoisted_81 = { class: "seq-profile-control" }
const _hoisted_82 = { class: "seq-profile-row" }
const _hoisted_83 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "First Name *", -1)
const _hoisted_84 = { class: "seq-profile-control" }
const _hoisted_85 = { class: "seq-profile-row" }
const _hoisted_86 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Last Name *", -1)
const _hoisted_87 = { class: "seq-profile-control" }
const _hoisted_88 = { class: "seq-profile-row" }
const _hoisted_89 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Email *", -1)
const _hoisted_90 = { class: "seq-profile-control" }
const _hoisted_91 = { class: "seq-profile-row" }
const _hoisted_92 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "AI 24/7 Password *", -1)
const _hoisted_93 = { class: "seq-profile-control" }
const _hoisted_94 = /*#__PURE__*/_createVNode("div", { class: "form-text text-muted mt-1" }, " This password is for logging into your AI 24/7 at app.ai247saas.com. It must be more than 12 characters and include uppercase, lowercase, numbers, and special characters. ", -1)
const _hoisted_95 = { class: "seq-profile-row" }
const _hoisted_96 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Confirm Password *", -1)
const _hoisted_97 = { class: "seq-profile-control" }
const _hoisted_98 = { class: "seq-profile-row" }
const _hoisted_99 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Phone *", -1)
const _hoisted_100 = { class: "seq-profile-control" }
const _hoisted_101 = { class: "seq-profile-row" }
const _hoisted_102 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Address *", -1)
const _hoisted_103 = { class: "seq-profile-control" }
const _hoisted_104 = { class: "seq-profile-row" }
const _hoisted_105 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "City *", -1)
const _hoisted_106 = { class: "seq-profile-control" }
const _hoisted_107 = { class: "seq-profile-row" }
const _hoisted_108 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "State / Region *", -1)
const _hoisted_109 = { class: "seq-profile-control" }
const _hoisted_110 = { class: "seq-profile-row" }
const _hoisted_111 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Postal Code *", -1)
const _hoisted_112 = { class: "seq-profile-control" }
const _hoisted_113 = { class: "seq-profile-row" }
const _hoisted_114 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Country *", -1)
const _hoisted_115 = { class: "seq-profile-control" }
const _hoisted_116 = /*#__PURE__*/_createVNode("option", { value: "" }, "Select country", -1)
const _hoisted_117 = { class: "seq-profile-row" }
const _hoisted_118 = /*#__PURE__*/_createVNode("label", { class: "seq-field-label seq-profile-label" }, "Timezone", -1)
const _hoisted_119 = { class: "seq-profile-control" }
const _hoisted_120 = /*#__PURE__*/_createStaticVNode("<option value=\"UTC\">UTC</option><option value=\"America/New_York\">America/New_York (Eastern)</option><option value=\"America/Chicago\">America/Chicago (Central)</option><option value=\"America/Denver\">America/Denver (Mountain)</option><option value=\"America/Los_Angeles\">America/Los_Angeles (Pacific)</option><option value=\"America/Phoenix\">America/Phoenix</option><option value=\"Pacific/Honolulu\">Pacific/Honolulu</option>", 7)
const _hoisted_127 = { class: "seq-profile-row mt-4" }
const _hoisted_128 = { class: "seq-profile-control" }
const _hoisted_129 = { class: "form-check" }
const _hoisted_130 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label text-muted fs-7",
  for: "ai247-accepted-legal"
}, [
  /*#__PURE__*/_createTextVNode(" I am 18 or older and I agree to the "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://ai247saas.com/terms-of-service",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Terms of Service"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://ai247saas.com/privacy-policy",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"),
  /*#__PURE__*/_createTextVNode(". I understand that I am the sender of my messages, and that my workspace runs on a third-party U.S. platform host and AI/payment providers as described. ")
], -1)
const _hoisted_131 = { class: "mt-5" }
const _hoisted_132 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_133 = { class: "ai247-instance-detail__footer" }
const _hoisted_134 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", null, [
        _hoisted_3,
        _createVNode("h3", _hoisted_4, _toDisplayString(_ctx.instanceTitle), 1),
        _createVNode("div", _hoisted_5, [
          (_ctx.location?.locationId)
            ? (_openBlock(), _createBlock("span", _hoisted_6, "Location " + _toDisplayString(_ctx.location.locationId), 1))
            : (_openBlock(), _createBlock("span", _hoisted_7, "Select an instance to view account details"))
        ])
      ]),
      (_ctx.statusBadge)
        ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.statusBadge), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.locationStat), 1),
        _hoisted_12
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, _toDisplayString(_ctx.createdStat), 1),
        _hoisted_15
      ]),
      (_ctx.hasPendingSlots)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            type: "button",
            class: "ai247-instance-detail__add-card",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('activate-another')))
          }, " + Activate another slot "))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_16, [
      (_ctx.subscription)
        ? (_openBlock(), _createBlock("div", _hoisted_17, [
            (_ctx.subscription.status === 'trialing')
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _createVNode("span", _hoisted_19, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Time-schedule.svg" })
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("span", _hoisted_21, "Free trial — " + _toDisplayString(_ctx.trialDaysLeft) + " day" + _toDisplayString(_ctx.trialDaysLeft === 1 ? "" : "s") + " left", 1),
                    _createVNode("span", _hoisted_22, " Your trial ends on " + _toDisplayString(_ctx.formatDate(_ctx.subscription.trialEndsAt)) + ". Choose a plan below to keep your AI 24/7 running after the trial. ", 1)
                  ])
                ]))
              : (_ctx.subscription.status === 'active')
                ? (_openBlock(), _createBlock("div", _hoisted_23, [
                    _createVNode("span", _hoisted_24, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Done-circle.svg" })
                    ]),
                    _createVNode("div", _hoisted_25, [
                      _createVNode("span", _hoisted_26, "Subscription active — " + _toDisplayString(_ctx.planLabel(_ctx.subscription.plan)), 1),
                      _createVNode("span", _hoisted_27, _toDisplayString(_ctx.subscription.autoRenew ? "Renews on" : "Valid until") + " " + _toDisplayString(_ctx.formatDate(_ctx.subscription.currentPeriodEnd)) + ". ", 1)
                    ])
                  ]))
                : (_ctx.subscription.status === 'past_due')
                  ? (_openBlock(), _createBlock("div", _hoisted_28, [
                      _createVNode("span", _hoisted_29, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-2.svg" })
                      ]),
                      _hoisted_30
                    ]))
                  : (_ctx.subscription.status === 'expired')
                    ? (_openBlock(), _createBlock("div", _hoisted_31, [
                        _createVNode("span", _hoisted_32, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-2.svg" })
                        ]),
                        _hoisted_33
                      ]))
                    : _createCommentVNode("", true),
            (_ctx.showPlanButtons)
              ? (_openBlock(), _createBlock("div", _hoisted_34, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    disabled: _ctx.subscribing,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('choose-plan', 'monthly')))
                  }, [
                    (_ctx.subscribing)
                      ? (_openBlock(), _createBlock("span", _hoisted_35))
                      : _createCommentVNode("", true),
                    _hoisted_36
                  ], 8, ["disabled"]),
                  _createVNode("button", {
                    type: "button",
                    class: "btn btn-light-primary",
                    disabled: _ctx.subscribing,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('choose-plan', 'quarterly')))
                  }, [
                    (_ctx.subscribing)
                      ? (_openBlock(), _createBlock("span", _hoisted_37))
                      : _createCommentVNode("", true),
                    _hoisted_38
                  ], 8, ["disabled"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.connected && _ctx.location)
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("div", _hoisted_39, [
              _createVNode("span", _hoisted_40, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Done-circle.svg" })
              ]),
              _hoisted_41
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode("table", _hoisted_43, [
                _createVNode("tbody", null, [
                  _createVNode("tr", null, [
                    _hoisted_44,
                    _createVNode("td", _hoisted_45, _toDisplayString(_ctx.location.locationId), 1)
                  ]),
                  _createVNode("tr", null, [
                    _hoisted_46,
                    _createVNode("td", _hoisted_47, [
                      _createVNode("span", _hoisted_48, _toDisplayString(_ctx.location.status === "suspended" ? "Disconnected" : _ctx.location.status), 1)
                    ])
                  ]),
                  (_ctx.location.createdAt)
                    ? (_openBlock(), _createBlock("tr", _hoisted_49, [
                        _hoisted_50,
                        _createVNode("td", _hoisted_51, _toDisplayString(_ctx.formatDate(_ctx.location.createdAt)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 64))
        : (_ctx.pendingApplication && _ctx.location)
          ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
              _createVNode("div", _hoisted_52, [
                _createVNode("span", _hoisted_53, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
                ]),
                _hoisted_54
              ]),
              _createVNode("div", _hoisted_55, [
                _createVNode("table", _hoisted_56, [
                  _createVNode("tbody", null, [
                    _createVNode("tr", null, [
                      _hoisted_57,
                      _createVNode("td", _hoisted_58, _toDisplayString(_ctx.location.locationId), 1)
                    ]),
                    _hoisted_59,
                    (_ctx.location.createdAt)
                      ? (_openBlock(), _createBlock("tr", _hoisted_60, [
                          _hoisted_61,
                          _createVNode("td", _hoisted_62, _toDisplayString(_ctx.formatDate(_ctx.location.createdAt)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 64))
          : (_ctx.location)
            ? (_openBlock(), _createBlock("div", _hoisted_63, [
                _createVNode("table", _hoisted_64, [
                  _createVNode("tbody", null, [
                    _createVNode("tr", null, [
                      _hoisted_65,
                      _createVNode("td", _hoisted_66, _toDisplayString(_ctx.location.locationId), 1)
                    ]),
                    _createVNode("tr", null, [
                      _hoisted_67,
                      _createVNode("td", _hoisted_68, [
                        _createVNode("span", _hoisted_69, _toDisplayString(_ctx.location.status === "suspended" ? "Disconnected" : _ctx.location.status), 1)
                      ])
                    ]),
                    (_ctx.location.createdAt)
                      ? (_openBlock(), _createBlock("tr", _hoisted_70, [
                          _hoisted_71,
                          _createVNode("td", _hoisted_72, _toDisplayString(_ctx.formatDate(_ctx.location.createdAt)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : (_ctx.statusLoaded && !_ctx.canSignup)
              ? (_openBlock(), _createBlock("div", _hoisted_73, [
                  _createVNode("span", _hoisted_74, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
                  ]),
                  _hoisted_75
                ]))
              : (_ctx.statusLoaded && _ctx.canSignup)
                ? (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                    _createVNode("div", _hoisted_76, [
                      _createVNode("span", _hoisted_77, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
                      ]),
                      _hoisted_78
                    ]),
                    _createVNode("form", {
                      onSubmit: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.$emit('submit-form')), ["prevent"])),
                      class: "seq-profile-form px-2"
                    }, [
                      _createVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _createVNode("div", _hoisted_81, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "seq-profile-input",
                            placeholder: "Account Name",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.businessName = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.form.businessName]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_82, [
                        _hoisted_83,
                        _createVNode("div", _hoisted_84, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "seq-profile-input",
                            placeholder: "First Name",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.firstName = $event)),
                            disabled: _ctx.submitting
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.form.firstName]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_85, [
                        _hoisted_86,
                        _createVNode("div", _hoisted_87, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "seq-profile-input",
                            placeholder: "Last Name",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.lastName = $event)),
                            disabled: _ctx.submitting
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.form.lastName]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_88, [
                        _hoisted_89,
                        _createVNode("div", _hoisted_90, [
                          _withDirectives(_createVNode("input", {
                            type: "email",
                            class: "seq-profile-input",
                            placeholder: "Email Address",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.email = $event)),
                            disabled: _ctx.submitting
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.form.email]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_91, [
                        _hoisted_92,
                        _createVNode("div", _hoisted_93, [
                          _withDirectives(_createVNode("input", {
                            type: "password",
                            class: "seq-profile-input",
                            placeholder: "AI 24/7 Password",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.password = $event)),
                            disabled: _ctx.submitting,
                            autocomplete: "new-password"
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.form.password]
                          ]),
                          _hoisted_94
                        ])
                      ]),
                      _createVNode("div", _hoisted_95, [
                        _hoisted_96,
                        _createVNode("div", _hoisted_97, [
                          _withDirectives(_createVNode("input", {
                            type: "password",
                            class: "seq-profile-input",
                            placeholder: "Confirm Password",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.confirmPassword = $event)),
                            disabled: _ctx.submitting,
                            autocomplete: "new-password"
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.form.confirmPassword]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_98, [
                        _hoisted_99,
                        _createVNode("div", _hoisted_100, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "seq-profile-input",
                            placeholder: "Phone Number",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.phone = $event)),
                            disabled: _ctx.submitting
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.form.phone]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_101, [
                        _hoisted_102,
                        _createVNode("div", _hoisted_103, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "seq-profile-input",
                            placeholder: "Street Address",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.address = $event)),
                            disabled: _ctx.submitting
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.form.address]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_104, [
                        _hoisted_105,
                        _createVNode("div", _hoisted_106, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "seq-profile-input",
                            placeholder: "City",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.city = $event)),
                            disabled: _ctx.submitting
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.form.city]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_107, [
                        _hoisted_108,
                        _createVNode("div", _hoisted_109, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "seq-profile-input",
                            placeholder: "State or Region",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.state = $event)),
                            disabled: _ctx.submitting
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.form.state]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_110, [
                        _hoisted_111,
                        _createVNode("div", _hoisted_112, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "seq-profile-input",
                            placeholder: "Postal Code",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.postalCode = $event)),
                            disabled: _ctx.submitting
                          }, null, 8, ["disabled"]), [
                            [_vModelText, _ctx.form.postalCode]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_113, [
                        _hoisted_114,
                        _createVNode("div", _hoisted_115, [
                          _withDirectives(_createVNode("select", {
                            class: "seq-profile-select",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.country = $event)),
                            disabled: _ctx.submitting
                          }, [
                            _hoisted_116,
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                              return (_openBlock(), _createBlock("option", {
                                key: country.country_id,
                                value: country.iso_code_2
                              }, _toDisplayString(country.name) + " (" + _toDisplayString(country.iso_code_2) + ") ", 9, ["value"]))
                            }), 128))
                          ], 8, ["disabled"]), [
                            [_vModelSelect, _ctx.form.country]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_117, [
                        _hoisted_118,
                        _createVNode("div", _hoisted_119, [
                          _withDirectives(_createVNode("select", {
                            class: "seq-profile-select",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.timezone = $event)),
                            disabled: _ctx.submitting
                          }, [
                            _hoisted_120
                          ], 8, ["disabled"]), [
                            [_vModelSelect, _ctx.form.timezone]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_127, [
                        _createVNode("div", _hoisted_128, [
                          _createVNode("div", _hoisted_129, [
                            _withDirectives(_createVNode("input", {
                              id: "ai247-accepted-legal",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.acceptedLegal = $event)),
                              class: "form-check-input",
                              type: "checkbox",
                              disabled: _ctx.submitting
                            }, null, 8, ["disabled"]), [
                              [_vModelCheckbox, _ctx.form.acceptedLegal]
                            ]),
                            _hoisted_130
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_131, [
                        _createVNode("button", {
                          type: "submit",
                          class: "btn btn-primary",
                          disabled: _ctx.submitting || !_ctx.form.acceptedLegal
                        }, [
                          (_ctx.submitting)
                            ? (_openBlock(), _createBlock("span", _hoisted_132))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.submitting ? "Creating subaccount..." : "Create AI 24/7"), 1)
                        ], 8, ["disabled"])
                      ])
                    ], 32)
                  ], 64))
                : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_133, [
      (_ctx.pendingApplication && _ctx.location)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-light btn-sm",
            disabled: _ctx.refreshing,
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('refresh')))
          }, [
            (_ctx.refreshing)
              ? (_openBlock(), _createBlock("span", _hoisted_134))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.refreshing ? "Checking status..." : "Refresh Status"), 1)
          ], 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_ctx.ghlAppUrl)
        ? (_openBlock(), _createBlock("a", {
            key: 1,
            href: _ctx.ghlAppUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "btn btn-light btn-sm"
          }, " Open AI 24/7 ", 8, ["href"]))
        : _createCommentVNode("", true)
    ])
  ]))
}